import fetchValuations from '../../../Services/fetchValuations'
import fetchValuationDates from '../../../Services/fetchValuationDates'

export default () => (dispatch) => {

  dispatch(fetchValuations())
  dispatch(fetchValuationDates())

}
